<template>
    <div class="super-block ad-front-page" :class="{'is-one-banner':isOneBanner, 'w-100': leftAd && leftAd.iframe_code}">
      <ad v-if="leftAd" :ad="leftAd" class="left-ad-main" :class="{is_left_only:!rightAd}" />
      <!--        <new-banner v-if="!ad"/>-->
      <AdUnit v-else-if="adLoad"/>
      <div style="opacity: 0;" v-else class="adunit-block"></div>


      <ad v-if="rightAd" :ad="rightAd" class="right-ad-main" />
      <MobileAppStore v-if="showRightBanner" />
    </div>
</template>


<script>
import {mapActions} from "vuex";
import Ad from "@/components/global/ad";
import AdUnit from "@/components/Dealers/AdUnit";
import MobileAppStore from "@/components/Dealers/MobileAppStore";

export default {
  props:{
    ad:{
      type: Object,
    },
    adLoad:{
      type: Boolean,
      default: false
    }
  },
  components:{
    Ad,
    AdUnit,
    MobileAppStore
  },
 /* data: () => ({
    ad: null,
    adLoad: true,
  }),*/
  methods:{
    ...mapActions({
      'getAd': "ad/GET",
    })
  },
  computed:{
    isOneBanner(){
      if(!this.rightAd){
        return  true;
      }
      if(!this.leftAd){
        return true;
      }
    },
    leftAd(){
      return this.adLoad && this.ad && this.ad.left;
    },
    rightAd(){
      return this.adLoad && this.ad && this.ad.right;
    },
    showRightBanner(){
      return !this.rightAd && !this.leftAd && this.adLoad;
    }
  }
}
</script>
